export default __webpack_public_path__ + "static/bg-f1bc4ab1d37d8dee2df08a610ab27330.jpg";